module.exports = __webpack_public_path__ + "static/img/menubg.fb456269.svg";